<div class="badge" [class]="'theme-' + badgeTheme">
  {{value}}
</div>
